import { MockCard, MockButton } from '../../components/mockups/MockUI'

export function ProcurementRequestsOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Запросы поставщикам — обзор
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Отдельный модуль для рассылки запросов поставщикам по позициям заявки. Доступен
          закупщикам, РОЗ и ADMIN. Используется когда нужно собрать цены сразу с нескольких
          поставщиков и потом импортировать их ответы как квоты.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Где открывается:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Из карточки заявки — кнопка «Запросы поставщикам»</li>
            <li>Из очереди закупки — выбрать позиции чекбоксами и нажать «Скачать запрос»</li>
          </ul>
          <p className="mt-2">
            В карточке запроса видно: список позиций, поставщика, статус каждого ответа и
            импортированные квоты.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function ProcurementRequestsCreate() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Создание запроса — «Кому отправляем запрос?»
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Выбрав позиции чекбоксами и нажав «Скачать запрос», вы попадаете в окно «Кому отправляем
          запрос?». Один поставщик = один Excel-файл (BOM). На каждого выбранного поставщика
          формируется отдельный файл.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Шаги:</div>
          <ol className="list-decimal list-inside space-y-1">
            <li>В очереди закупки отметьте позиции чекбоксами</li>
            <li>
              Нажмите <MockButton variant="secondary">Скачать запрос</MockButton> — откроется окно
              «Кому отправляем запрос?»
            </li>
            <li>Отметьте чекбоксами поставщиков из своего списка (можно искать по названию)</li>
            <li>Нового поставщика можно вписать прямо в поле — он добавится в ваш список</li>
            <li>При необходимости впишите заметку (например, ссылку на чат WeChat)</li>
            <li>
              Нажмите <MockButton>Скачать</MockButton> — система создаст по файлу на каждого
              поставщика и переведёт позиции в «Запрос отправлен»
            </li>
          </ol>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Личный список поставщиков:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>Список поставщиков в окне — персональный, у каждого закупщика свой</li>
            <li>Поставщик добавляется в список автоматически при первом запросе ему</li>
            <li>
              Кнопка <span className="font-medium">×</span> рядом с поставщиком убирает его из
              вашего списка-подсказок (у других закупщиков он остаётся)
            </li>
            <li>
              Кнопка <MockButton variant="secondary">Без поставщика</MockButton> — скачивает
              «ноунейм»-файл из выбранных позиций, без записи запроса и без смены статусов позиций.
              Удобно, когда нужен просто Excel со списком, а не рассылка
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function ProcurementRequestsImport() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Импорт ответа поставщика
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Поставщик заполняет цены в том же Excel-файле и присылает его обратно. Система определяет
          файл по скрытому коду в шапке (fileCode) — даже если поставщик переименовал файл, привязка
          к запросу не теряется.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Что происходит при импорте:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              При скачивании запроса по каждой позиции уже создаётся квота-«заготовка» без цены
              (заметка «Запрос поставщику отправлен»)
            </li>
            <li>Цена больше 0 в ответе → заготовка обновляется реальной ценой и заметкой</li>
            <li>Цена 0 → заготовка получает цену 0 и заметку «Позиция отсутствует»</li>
            <li>Пустая строка в ответе → заготовка так и остаётся заготовкой</li>
            <li>
              Дубли квот не плодятся — обновляется та же заготовка, что создана при скачивании
            </li>
            <li>Менеджер заявки получает одно агрегированное уведомление вместо N штук</li>
          </ul>
          <p className="mt-2">
            Если все отправленные поставщикам запросы по позиции отвечены ценой 0 — позиция
            автоматически уходит в статус «Не найдено». Появление реальной цены вернёт её в работу.
          </p>
        </div>
      </MockCard>
    </div>
  )
}
